import React from 'react';
import MenuForm from './MenuForm';

const MenuUploadForm = ({ onSuccess, initialData = null, isPersonal = false, isAdmin = false }) => {
  return (
    <MenuForm
      onSuccess={onSuccess}
      initialData={initialData}
      isAdmin={isAdmin}
      isPersonal={isPersonal}
    />
  );
};

export default MenuUploadForm; 